var ClinicMedicationRequest = /** @class */ (function () {
    function ClinicMedicationRequest(_a) {
        var PublicToken = _a.PublicToken;
        this.Action = 'clinicmedication';
        this.PublicToken = PublicToken;
    }
    return ClinicMedicationRequest;
}());
export { ClinicMedicationRequest };
